import styled, { css } from 'styled-components';

export const StyledLocationFilter = styled.div`
  height: auto;
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.LIGHT_SILVER};
  padding-bottom: 18px;
`;

export const FilterPicker = styled.div`
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  border-radius: 3px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  margin-top: 24px;
  margin-bottom: 6px;
  height: 36px;
  display: flex;
  justify-content: space-between;
`;

const labelVariants = {
  unselected: css`
    background-color: ${({ theme }) => theme.COLORS.BASE};
    color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  `,
  selected: css`
    background-color: ${({ theme }) => theme.COLORS.TERTIARY};
    color: ${({ theme }) => theme.COLORS.BASE};
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  `
};

export const LabelButton = styled.button`
  width: 108px;
  text-align: center;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.DEEP_GREY};
  ${props => labelVariants[props.variant]};
  outline: none;
  border: none;
  cursor: pointer;
  border-radius: 3px;
`;
